import React from 'react'
import PropTypes from 'prop-types'
import MaskedInput from 'react-text-mask'

// eslint-disable-next-line no-unused-vars
export const TextMaskCustom = React.forwardRef(({ mask, ...props }, ref) => {
  return <MaskedInput {...props} mask={mask} placeholderChar={'\u2000'} />
})

TextMaskCustom.displayName = 'TextMaskCustom'

TextMaskCustom.propTypes = {
  mask: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(RegExp)])
    ),
    PropTypes.func,
  ]).isRequired,
}

TextMaskCustom.defaultProps = {}

export default TextMaskCustom
